// English strings of the 3D scene (decision D13: English first). Another language
// adds a file next to this one with the same shape.

export const strings = {
  label: "3D engine view",
  cameras: "Camera",
  display: { label: "Motion", strobe: "Strobe", trueSpeed: "True speed" },
  displayHint: {
    strobe: "Slowed to at most one turn a second, so the parts can be followed.",
    trueSpeed: "The crank as fast as it turns: a screen cannot show this without jumps.",
  },
  pickHint: "Click a part to name it.",
  cutFace: "cut face",
  cylinder: "cylinder",
  noWebGl: "This browser cannot draw the 3D view (WebGL2 is not available).",
  noModel: "No 3D model is committed yet.",
  loadFailed: "The 3D model did not load.",
};
